import { render } from "./MImageInput.vue?vue&type=template&id=ef8563b0&scoped=true"
import script from "./MImageInput.vue?vue&type=script&lang=js"
export * from "./MImageInput.vue?vue&type=script&lang=js"

import "./MImageInput.vue?vue&type=style&index=0&id=ef8563b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8563b0"]])

export default __exports__